/**
 * Sample faces (2026-02-10) — bundled DiceBear 'shapes' SVGs (see @toiyp/shared
 * faces.ts for the id registry and the art credit). Rendered as plain <img>
 * against the bundled file, so faces are offline-safe and cost nothing at
 * runtime.
 *
 * The `?v=` query is a deliberate cache-buster: the avatar URLs are stable but
 * the art changes between releases, and a stale blob pinned by the browser or
 * a service-worker cache must never survive a redeploy (2026-02-10). Bump the
 * version when the face art changes.
 */

import { FACE_LABELS, type FaceId } from '@toiyp/shared';

const FACE_ASSET_VERSION = '4';

/** The bundled asset for a face id — versioned so cache can never pin old art. */
export function faceImageUrl(id: FaceId): string {
  return `${import.meta.env.BASE_URL}avatars/${id}.svg?v=${FACE_ASSET_VERSION}`;
}

/** An <img> sized to fill its avatar circle (decorative; label from parent). */
export function FaceImage({ id, className }: { id: FaceId; className?: string }) {
  return (
    <img
      src={faceImageUrl(id)}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className={className}
      title={FACE_LABELS[id]}
    />
  );
}